import { Select } from '@material-ui/core';
import * as lib from '~/dependencies';
import { colors, measures } from '~/layout';

export const Container = lib.styled.div`
  display: flex;
  position: absolute;
  flex-direction: column;
  top: 0px;
  right: 0px;
  background-color: ${colors.white02};
  width: ${measures.content.width}px;
  height: 100%;
  max-height: ${measures.content.height}px;
  z-index: 99;
  align-items: center;
  justify-content: space-between;
`;

export const Header = lib.styled.div`
  display: flex;
  height: 70px;
  width: 100%;
`;

export const Body = lib.styled.div`
  display: flex;
  flex: 1;
  width: 100%;
  // height: ${props => props.height - 80}px;
  height: 640px;

  div {
    display: flex;
    align-items: center;
    justify-content: center;
    max-width: ${props => props.width}px;
    width: ${props => props.width}px;

    svg {
      width: ${props => props.width}px!important;
      height: auto!important;
    }
  }

  .title {
    font-size: ${colors.black};
  }
`;

export const Progress = lib.styled.div`
  display: flex;
  flex: 1;
  height: 30px;
  width: 100%;
  align-items: center;
  justify-content: center;
`;

export const Row = lib.styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: ${props => (props.center ? 'center' : 'space-between')};
  min-height: 30px;

  .button-action {
    width: 100px;
    height: 35px;
    border: 0;
    box-shadow: none;
    outline: none;
    cursor: pointer;
    font-size: 12px;
    color: ${colors.darkGray03};
    background-color: transparent;
    text-transform: uppercase;
    font-weight: 500;
  }
  .active {
    background-color: ${colors.green02};
    border-radius: 30px;
    color: ${colors.white}!important;
    text-transform: none!important;
    margin-right: 10px;
  }
  .skip {
    border: 0;
    box-shadow: none;
    outline: none;
    cursor: pointer;
    font-size: 11px;
    background-color: transparent;
    color: ${colors.link};
    text-transform: lowercase;
    margin-bottom: 15px;
  }
`;

export const Ball = lib.styled.div`
  width: ${props => (props.selected ? '10' : '9')}px;
  height: ${props => (props.selected ? '10' : '9')}px;
  margin: ${props => (props.selected ? '3' : '4')}px;
  opacity: ${props => (props.selected ? '1' : '0.5')};
  border-radius: 30px;
  background-color: ${colors.green02};
  cursor: pointer;
`;

export const Footer = lib.styled.div`
  display: flex;
  flex-direction: column;
  height: 80px;
  max-height: 80px;
  min-height: 80px;
  width: 100%;
  margin-top: 10px;
`;

export const AudioSettings = lib.styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  .title {
    margin-top: 10px;
    font-size: 18px;
    font-weight: bold;
  }

  .subtitle {
    font-weight: 700;
    align-self: flex-start;
    margin: 10px 0 10px 20px;
  }

  .icon {
    width: 45px!important;
    height: auto!important;
    color: ${colors.white};
  }

  .mic {
    background-color: ${colors.green};
  }

  .input {
    width: 100%!important;
    margin-top: 3px;
  }
`;

export const Icon = lib.styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 80px;
  border-radius: 50px;
  background-color: ${colors.lightBlue}
`;

export const Mic = lib.styled.div`
  width: 100%;
  margin-top: 40px;
  max-width: 343px;

  span {
    font-weight: bold;
  }

  .icon-2 {
    width: 25px;
    height: auto;
  }

  .row {
    display: flex;
    flex-direction: row;
    margin-left: -3px;
  }

  .mic-analyzer {
    margin-top 7px;
  }
`;

export const SelectDevice = lib.styled(Select)`
  .MuiInput-root {
    border-bottom: ${colors.lightBlue}!important;
  }
`;

export const AudioTest = lib.styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  cursor: pointer;
  margin-top: 10px;


  .icon {
    display: flex;
    width: 25px!important;
    height: 25px!important;
    justify-content: center;
    align-items: center;
    background-color: ${colors.lightBlue};
    border-radius: 50px;
    margin-right: 10px;

    .MuiSvgIcon-root {
      font-size: 20px;
    }
  }

  span {
    font-weight: 500;
  }
`;

export const CallTest = lib.styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  margin-top: 50px;

  .MuiSvgIcon-root {
    font-size: 20px;
    margin-right: 10px;
  }

  &:hover {
    opacity: .7;
  }
`;
